import { render, staticRenderFns } from "./UpdatesHistory.vue?vue&type=template&id=1c9ece34&scoped=true"
import script from "./UpdatesHistory.vue?vue&type=script&lang=js"
export * from "./UpdatesHistory.vue?vue&type=script&lang=js"
import style0 from "./UpdatesHistory.vue?vue&type=style&index=0&id=1c9ece34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9ece34",
  null
  
)

export default component.exports